<h5 class="widget-header" *ngIf="(hayLinks || (isAdmin||isContribuidor))"><i class="fas fa-link"></i> Enlaces Relacionados</h5>
<span *ngIf="(isAdmin||isContribuidor) && (respuestaId)">Asociar enlace <a (click)="nuevoLink()" data-toggle="tooltip" title="Nuevo Link"  class="btn btn-primary add"><i class="fas fa-plus"></i></a></span>
<ul class="btn-toggle-nav list-unstyled fw-normal" *ngFor="let link of links">
 <!-- <li ><a (click)="gotoLink(link.descripcion)" class="list-group-item nav-link">{{link.nombre}}</a></li>-->
  <li>
    <h4>
      <a target="_blank" rel="noreferrer noopener" (click)="aviso(link.tipo,link.descripcion)" [ngClass]="[link.tipo=='interno' ? 'linkInterno' : 'linkExterno']" >{{link.nombre}}</a>&nbsp;
      <span *ngIf="link.tipo=='interno'">
        <a (click)="editarLink(link.id)" data-toggle="tooltip" title="Editar Link" *ngIf="isAdmin||isContribuidor"  class="btn_ico"><i class="far fa-edit"></i></a>
        <a (click)="borrarLink(link.id, link.nombre)" data-toggle="tooltip" title="Eliminar Link" *ngIf="isAdmin" class="btn_ico"><i class="far fa-trash-alt"></i></a>
    </span>
    <span *ngIf="link.tipo=='externo'">
      <a (click)="editarLink(link.id)" data-toggle="tooltip" title="Editar Link" *ngIf="isAdmin||isContribuidor" class="btn_ico"><i class="far fa-edit "></i></a>
      <a (click)="borrarLink(link.id, link.nombre)" data-toggle="tooltip" title="Eliminar Link" *ngIf="isAdmin"  class="btn_ico"><i class="far fa-trash-alt"></i></a>
  </span>
  </h4>
  </li>
</ul>
<br>
<app-loading *ngIf="loading" class="m-5"></app-loading>
